import { getDeliveriesByType } from 'src/components/restructure/common/FreightSimulation/utils/getDeliveriesByType'
import { useMemo } from 'react'
import { TruckShippingIcon } from 'src/components/Icons/TruckShippingIcon'

import { useProductPageContext } from '../../../contexts'

export function FlagNextDayDelivery() {
  const { deliveryIsAvailable, freightSimulationValue } =
    useProductPageContext()

  const nextDayDeliveries = useMemo(() => {
    return getDeliveriesByType('next-day', freightSimulationValue)
  }, [freightSimulationValue])

  if (
    !deliveryIsAvailable ||
    !nextDayDeliveries ||
    nextDayDeliveries?.length === 0
  ) {
    return <></>
  }

  return (
    <div
      data-dy-id="flag-next-day-delivery"
      className="p-1.5 hidden gap-2 bg-mint mt-4 mb-6 justify-center items-center restructure-tablet:w-fit"
    >
      <TruckShippingIcon color="#101010" />
      <p className="text-font-size-2 text-restructure-primary font-medium">
        Receba até amanhã!
      </p>
    </div>
  )
}
